var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "video-player"
  }, [_c('div', {
    staticClass: "video-player__container"
  }, [_c('div', {
    staticClass: "video-player__wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.type === 'video' ? _c('div', {
    key: _vm.source
  }, [_c('video', {
    key: _vm.source,
    ref: "video",
    attrs: {
      "src": _vm.$store.state.assetsPath + _vm.source,
      "playsinline": "",
      "disablePictureInPicture": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    on: {
      "ended": _vm.onEnd,
      "play": _vm.onPlay,
      "timeupdate": _vm.onTimeUpdate
    }
  }), _vm.playbackProgress > 0 ? _c('div', {
    staticClass: "video-player__progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: "width: ".concat(_vm.playbackProgress, "%")
  })]) : _vm._e()]) : _vm._e(), _vm.type === 'image' ? _c('div', {
    key: _vm.source
  }, [_c('img', {
    key: _vm.source,
    ref: "image",
    attrs: {
      "src": _vm.$store.state.assetsPath + _vm.source,
      "alt": ""
    }
  })]) : _vm._e()])], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }